import { isEmpty } from 'lodash-es';
import { DentalInsuranceReportTypes } from '@frontend/api-insurance-eligibility-report';
import { useTranslation } from '@frontend/i18n';
import { titleCase } from '@frontend/string';
import { Heading } from '@frontend/design-system';
import { RelationshipEnum } from '../../../constants';
import { getFormattedAddress } from '../../../helpers/get-extras.helper';
import { getRelationShipValue } from '../../../utils/utils';
import { SectionInfo } from './SectionInfo';
import { insuranceDetailsContainerStyles, sectionInfoContainerStyles } from './styles';

type PatientDetailsProps = {
  personDetails: DentalInsuranceReportTypes.Patient;
  relationship: string;
};

export const PatientDetails = ({ personDetails, relationship }: PatientDetailsProps) => {
  const { t } = useTranslation('insuranceEligibilityReport');

  if (isEmpty(personDetails)) return null;

  const patientName = `${titleCase(personDetails?.firstName ?? '')} ${titleCase(personDetails?.lastName ?? '')}`.trim();

  const formattedAddress = getFormattedAddress({
    addressLine1: personDetails?.address?.address1,
    city: personDetails?.address?.city,
    state: personDetails?.address?.state,
    zipCode: personDetails?.address?.zipCode,
  });

  const relationShipValue = getRelationShipValue((relationship || '') as RelationshipEnum);

  return (
    <div css={insuranceDetailsContainerStyles}>
      <Heading level={3}>{t('Patient Details')}</Heading>
      <div css={sectionInfoContainerStyles}>
        <SectionInfo label={t('Name')} value={patientName || '-'} />
        <SectionInfo label={t('Date of Birth')} value={personDetails?.dateOfBirth || personDetails?.dob || '-'} />
        <SectionInfo label={t('Relationship')} value={relationShipValue || '-'} />
      </div>
      <div css={sectionInfoContainerStyles}>
        <SectionInfo label={t('Address')} value={formattedAddress || '-'} />
      </div>
    </div>
  );
};
